var render, staticRenderFns
import script from "./BaseCard.vue?vue&type=script&lang=ts&"
export * from "./BaseCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eef02da",
  null
  
)

export default component.exports